import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";

// Custom Component
import Legend from "../../../Legend/Legend";

// Custom Style
import { rfiDetailFormStyle } from "../../../../styles/jss/components/RFI/rfiDetailFormStyle";

const useStyles = makeStyles((theme) => rfiDetailFormStyle(theme));
const TransmittalReturnComment = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { submissionValue } = props;

  return (
    <Fragment>
      <Grid item xs={12}>
        <Box border={1} borderColor={"grey.500"} className={classes.boxArea}>
          <Typography variant="subtitle1" className={classes.headerText}>
            Return Comment History
          </Typography>
          <Divider className={classes.divider} />
          {submissionValue.returnComments.map((obj, index) => {
            return (
              <div key={index}>
                <Grid item xs={12}>
                  <div className={classes.itemText}>
                    <p>
                      Return by:{obj.rcpt_category} {obj.createuser} At{" "}
                      {obj.createdate}
                    </p>
                    <p>Return Reason: {obj.returncomment}</p>
                  </div>
                </Grid>
                <hr />
              </div>
            );
          })}
        </Box>
      </Grid>
    </Fragment>
  );
};

export default TransmittalReturnComment;
